module.exports = __webpack_public_path__ + "img/loginbg.f830b44f.png";